<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="setManagerSupervisorName() + '\'s ledger'"
      :breadcrumbcurrent="setManagerSupervisorName() + '\'s ledger'"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" md="2">
                            <v-text-field clearable dense outlined v-model="dt_searchQuery" label="Search"></v-text-field>
                        </v-col> -->
            <v-col cols="12" lg="2" class="span-label">
              <span v-html="setManagerSupervisorName()"></span>
              <agent-credit-autocomplete-template
                ref="agent_autocomplete"
              ></agent-credit-autocomplete-template>
            </v-col>
            <v-col cols="12" md="12" lg="4" xl="2">
              <v-text-field
                clearable
                dense
                v-model="dt_DateFrom"
                label="Date from"
                type="date"
                class="regular-field"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12" lg="4" xl="2">
              <v-text-field
                clearable
                dense
                v-model="dt_DateTo"
                label="Date to"
                type="date"
                class="regular-field"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <!-- <v-col cols="12" md="3" lg="3" xl="2">
                            <v-btn color="info" class="float-right btn-block" @click="modalForm">Add area</v-btn>
                        </v-col> -->

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.totalgmbets`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.totalgmbets | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.totalappbets`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.totalappbets | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.totalcashins`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.totalcashins | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.totalcashouts`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.totalcashouts | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.totalpayouts`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.totalpayouts | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.level`]="{ item }">
                  L{{ item.level }}</template
                >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_DateFrom: this.$moment().format("YYYY-MM-DD"),
      dt_DateTo: this.$moment().format("YYYY-MM-DD"),
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          sortable: true,
          searchable: false,
          align: " d-none",
        },
        {
          text: "Account #",
          value: "account_no",
          name: "account_no",
          sortable: false,
          searchable: false,
        },
        {
          text: "Manager/Supervisor",
          value: "manager",
          name: "manager",
          sortable: false,
          searchable: false,
        },
        {
          text: "Level",
          value: "level",
          name: "level",
          sortable: false,
          searchable: false,
        },
        {
          text: "Contact #",
          value: "mobilenumber",
          name: "mobilenumber",
          sortable: false,
          searchable: false,
        },
        {
          text: "GM bet",
          value: "totalgmbets",
          name: "totalgmbets",
          sortable: false,
          searchable: false,
        },
        {
          text: "App bet",
          value: "totalappbets",
          name: "totalappbets",
          sortable: false,
          searchable: false,
        },
        {
          text: "Daily player cash-ins",
          value: "totalcashins",
          name: "totalcashins",
          sortable: false,
          searchable: false,
        },
        {
          text: "Daily player cash-outs",
          value: "totalcashouts",
          name: "totalcashouts",
          sortable: false,
          searchable: false,
        },
        {
          text: "Daily player payouts",
          value: "totalpayouts",
          name: "totalpayouts",
          sortable: false,
          searchable: false,
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
      subagent:
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null,
      agent_id: null,
      form: new this.$Form({
        id: null,
        name: null,
        address: null,
      }),
    };
  },
  methods: {
    setManagerSupervisorName(){
      if(this.$store.state.currentUser.agent_data.level == 0){
        return 'Manager';
      }
      else if(this.$store.state.currentUser.agent_data.level == 1){
        return 'Supervisor';
      }
      else if(this.$store.state.currentUser.agent_data.level == 2){
        return 'Supervisor';
      }
      else{
        return 'Manager';
      }
    },
    schedule_draw_format(val) {
      // let data = [];
      // val = JSON.parse(val);
      // val.forEach(element => {
      //     data.push(element.name);
      // });
      // return data.join(', ');
    },
    modalForm() {
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_AREAS"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          this.$Swal.fire(
            "Success!",
            "Record has been successfully added.",
            "success"
          );
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async findData(data) {
      this.formerror = {};
      this.form.reset();
      this.form.fill(data);
      this.modalUpdate = true;
      this.dialogForm = true;
    },
    async updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_AREAS") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      this.isLoadingBtnDelete = true;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete all record?"
        )
      ) {
        this.$axios
          .post(this.$_CONFIG.api() + "/destroyzone", { zone: id })
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      let subagent =
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null;
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      } catch (error) {
        subagent =
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null;
      }
      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        filterDateFrom: this.dt_DateFrom,
        filterDateTo: this.dt_DateTo,
        agent_id: subagent,
        // agent_id: this.$refs.agent_autocomplete.autocomplete_model.id,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api()) + "/supervisorledger";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
  },
  created() {
    this.getDataFromApi();
  },
  mounted() {},
};
</script>
<style scoped></style>